const field = (label, value) => (
	<div>
		<p className='text-xs text-gray-500'>{label}</p>
		<p className='text-sm'>{value || value === 0 ? value : '—'}</p>
	</div>
);

export default function ErpTab({ product }) {
	const variants = product.variants || [];

	return (
		<div className='max-w-2xl space-y-6'>

			<div className='grid grid-cols-2 gap-x-6 gap-y-4'>
				{field('ERP Inventory Item ID', product.erpProductNumber)}
				{field('ERP Estimate ID', product.erpEstimateId)}
				{field('Last Synced', product.lastSyncedAt ? new Date(product.lastSyncedAt).toLocaleString() : null)}
			</div>

			{variants.length > 0 && (
				<div>
					<h3 className='text-sm font-medium mb-2'>Variants</h3>
					<div className='overflow-x-auto'>
						<table className='w-full text-sm'>
							<thead>
								<tr className='border-b border-gray-200 text-left text-gray-500'>
									<th className='py-2 pr-4 font-medium'>SKU</th>
									<th className='py-2 pr-4 font-medium'>ERP Inventory Item ID</th>
									<th className='py-2 pr-4 font-medium'>ERP Estimate ID</th>
								</tr>
							</thead>
							<tbody>
								{variants.map((v) => (
									<tr key={v.productVariantId} className='border-b border-gray-100'>
										<td className='py-2 pr-4'>{v.sku || '—'}</td>
										<td className='py-2 pr-4'>{v.erpInventoryItemId || '—'}</td>
										<td className='py-2 pr-4'>{v.erpEstimateId || '—'}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			)}
		</div>
	);
}
